<template>
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <t-watermark class="h-full !overflow-visible" v-bind="watermarkProps">
        <result v-if="status === '403'" :tip="$t('抱歉，您无权限访问此页面')" />
        <result v-else-if="status === '500'" :tip="$t('抱歉，服务器出错啦')" />
        <component :is="Component" :key="route.fullPath" />
      </t-watermark>
    </transition>
  </router-view>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import type { UserInfo } from '@/store';
import result from '@tencent/iegsp-common/components/result/result.vue';
import { useRoute } from 'vue-router';
import { usePermissionStore, hasPermission, useUserStore } from '@/store';
import { PermsStatusEnum } from '@tencent/iegsp-common/tools/utils/route';

const { perm, permStatus } = storeToRefs(usePermissionStore());
const { watermarkContent } = storeToRefs(useUserStore());

const route = useRoute();
defineProps<{
  userInfo?: UserInfo;
}>();

const status = computed(() => {
  if (permStatus.value === PermsStatusEnum.fail) return '500';
  if (permStatus.value === PermsStatusEnum.success) {
    if (!hasPermission(route as any, perm.value)) return '403';
  }
  return '200';
});

const watermarkProps = computed(() => ({
  watermarkContent: {
    text: ['Login', 'Register'].includes(route.name as string) ? '' : watermarkContent.value,
    fontColor: 'black',
  },
  width: 320,
  height: 120,
  y: 120,
  x: 80,
  zIndex: 999,
  alpha: 0.08,
  offset: [0, 130],
}));
</script>
<style lang="less" scoped>
.fade-leave-active,
.fade-enter-active {
  transition: opacity @anim-duration-slow @anim-time-fn-easing;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
